


















import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import BaseTable from "../components/common/BaseTable.vue";
import AxiosMixin from "../mixins/axiosMixin";
import { HeaderWidthItem, SearchCondition, ObjectId } from "@/types";
import { Ref } from "vue-property-decorator";
import LoadingDialog from "../components/common/LoadingDialog.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    TextMonthChangePicker,
    BaseTable,
    LoadingDialog
  }
})
export default class CareSpecification extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  private headerItems: HeaderWidthItem[] = [
    {
      value: "is_printed",
      text: "請求データ確定済",
      width: "96px"
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px"
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px"
    },
    {
      value: "name",
      text: "氏名",
      width: "140px"
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "140px"
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px"
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "190px"
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "108px"
    },
    {
      value: "edit",
      text: "編集",
      width: "0px"
    }
  ];

  private tableItems: object[] = [];

  mounted() {
    const searchCondition: SearchCondition = {
      isDone: true,
      insuranceNo: "",
      insuranceName: "",
      userCode: "",
      userKana: "",
      userInsNo: ""
    };
    if (this.$route.query.only) {
      if (this.$route.query.only == "false") {
        searchCondition.isDone = false;
      }
    }
    if (typeof this.$route.query.insurance_no === "string") {
      searchCondition.insuranceNo = this.$route.query.insurance_no;
    }
    if (typeof this.$route.query.insurance_name === "string") {
      searchCondition.insuranceName = this.$route.query.insurance_name;
    }
    if (typeof this.$route.query.ibow_id === "string") {
      searchCondition.userCode = this.$route.query.ibow_id;
    }
    if (typeof this.$route.query.furigana === "string") {
      searchCondition.userKana = this.$route.query.furigana;
    }
    if (typeof this.$route.query.insured_no === "string") {
      searchCondition.userInsNo = this.$route.query.insured_no;
    }
    this.baseTable.setSearchCondition(searchCondition);
    this.updateData(this.baseTable.getSearchCondition());
  }

  // @Watch("yearmonth")
  // onYearmonthChanged(newYearmonth: string, oldYearmonth: string) {
  //   if (oldYearmonth != newYearmonth) {
  //     this.updateData(this.baseTable.getSearchCondition());
  //   }
  // }

  private updateData(searchCondition: SearchCondition) {
    this.postJsonCheck(
      window.base_url + "/api/office/care/specification/get",
      {
        yearmonth: this.yearmonth.replace("-", ""),
        only_not_printed: searchCondition.isDone,
        insurance_no: searchCondition.insuranceNo,
        insurance_name: searchCondition.insuranceName,
        ibow_id: searchCondition.userCode,
        furigana: searchCondition.userKana,
        insured_no: searchCondition.userInsNo
      },
      res => {
        this.tableItems = res.data.specifications;
        this.baseTable.refreshSelectItem();
        this.$router
          .replace(
            `/care/specification?only=${searchCondition.isDone}&insurance_no=${searchCondition.insuranceNo}&insurance_name=${searchCondition.insuranceName}&ibow_id=${searchCondition.userCode}&furigana=${searchCondition.userKana}&insured_no=${searchCondition.userInsNo}`
          )
          .catch(err => err);
        this.$nextTick(() => {
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  private search(searchCondition: SearchCondition) {
    this.updateData(searchCondition);
  }

  private done(objectIds: ObjectId[]) {
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/care/specification",
      {
        ids: objectIds.map(objectId => objectId.id)
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  private checked(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/care/specification/checked",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "◯";
        });
      }
    );
  }

  private cancel(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/care/specification/cancel",
      {
        ids: ids
      },
      () => {
        objectIds.forEach(item => {
          item.is_printed = "";
        });
      }
    );
  }

  private edit(item: ObjectId) {
    this.$router.push({
      path:
        "/care/edit/" +
        item.patient_id +
        "?tab=specification&specification_id=" +
        item.id
    });
  }
}
